module.exports = __webpack_public_path__ + "static/media/04.417178d9.jpg";